import makeRequest from '../../../../common/utils/makeRequest';
import { completeMultipartUploadQuery } from '../queries';


async function completeS3MultipartUpload(apiClient,
uploadId,
bucketKey,
organisationId,
parts,
assetIdToTranscode) {
  const { data, error } = await makeRequest({
    request: apiClient.query,
    requestParams: {
      query: completeMultipartUploadQuery,
      variables: { bucketKey, uploadId, organisationId, parts, assetIdToTranscode },
      context: { module: 'upload' },
      fetchPolicy: 'network-only'
    }
  });

  if (!data || !data.completeMultipartUpload || error) {return null;}

  return data.completeMultipartUpload;
}

export default completeS3MultipartUpload;